import Clickable from "@insite/mobius/Clickable";
import Icon from "@insite/mobius/Icon";
import XCircle from "@insite/mobius/Icons/XCircle";
import Typography from "@insite/mobius/Typography";
import ProductQuantityWrapper from "@thkStore/Overrides/Components/ProductQuantityWrapper";
import React from "react";
import styled from "styled-components";

const CardWrapper = styled.div`
    background-color: #EBEBEB;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    border-radius: 4px;
`;

const CardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
`;

const ProductInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

const TraitList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 4px;
`;
const RemoveButton = styled(Clickable)`
    flex-shrink: 0;
`;

interface Props {
    customProductId: string;
    productName: string;
    qtyOrdered: number;
    daysToShip: string;
    unitPrice: number;
    unitOfMeasureDisplay: string;
    onQuantityChange: (qty: number) => void;
    onRemove: () => void;
    editCustomInclude: () => void;
}

const IncludeCustomProductCard: React.FC<Props> = ({ customProductId, productName, daysToShip, unitPrice, unitOfMeasureDisplay, qtyOrdered, onQuantityChange, onRemove, editCustomInclude }) => {    

    return (
        <CardWrapper data-test-selector={`includeProductCard_${customProductId}`}>
            <CardHeader>
                <ProductInfo>
                    <Typography weight="bold" size={14} onClick={editCustomInclude}>
                        {productName}
                    </Typography>
                    <TraitList>
                        <Typography>{`$${unitPrice.toFixed(2)} / ${unitOfMeasureDisplay}`}</Typography>
                        <Typography>{`Days to Ship: ${daysToShip}`}</Typography>
                    </TraitList>                                       
                </ProductInfo>
                <RemoveButton
                    onClick={onRemove}
                    data-test-selector={`removeInclude_${customProductId}`}
                >
                    <Icon src={XCircle} size={15} />
                </RemoveButton>
            </CardHeader>
            <ProductQuantityWrapper
                value={qtyOrdered}
                onChange={onQuantityChange}
                min={1}
                dataTestSelector={`includeQty_${customProductId}`}
            />
        </CardWrapper>
    );
};

export default IncludeCustomProductCard;
